import React from 'react';
import { DETAILS_CONTENT_KEYS, IPlanContent } from '../typings';
import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';
import {
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
  gasKeyDetailsAddons,
} from './common/planDefaults';
import { Text, TextLink } from '@origin-digital/ods-core';
import { BYOBattery } from './common/BYOBatteryModal';
import { InternetOfferPerk } from './common/internetOfferPerk';

const PLAN_TONE = 'promoteB';

const solarInfoContent = (
  <Text>
    With Origin Solar Boost Plus, you must purchase an eligible solar PV system from us, your solar
    PV system must be net metered and must not be larger than 10kW. You must not be receiving a
    feed-in tariff under any government scheme. When your energy plan ends, you’ll receive our
    standard retailer feed-in tariff as published on our website. Feed-in tariff rates are GST
    inclusive (where applicable). For Victorian customers, the 
    <TextLink
      href="https://www.originenergy.com.au/terms-and-conditions/vic-feed-in-tariff/"
      target="_blank"
    >
      Terms and Conditions for Feed-in Tariffs - Victoria
    </TextLink>
     apply to both the additional feed-in tariff and standard retailer feed-in tariff.
  </Text>
);

export const originSolarBoostPlusContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Solar Boost Plus']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 24 month energy plan',
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: [
          {
            contentKey: DETAILS_CONTENT_KEYS.Rates,
            contentValue: 'Variable',
            modalContent: PlanKeyDetailsModal,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
            contentDescription: 'Variable rates',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.ExitFees,
            contentValue: 'No',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
            contentDescription: 'No exit fees. Leave anytime.',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
            contentValue: '24 months',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
            contentDescription: '24 month benefit period',
          },
        ],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        gas: gasKeyDetailsAddons,
        dual: [
          ...dualKeyDetailsAddons,
          {
            contentKey: DETAILS_CONTENT_KEYS.BYOBattery,
            contentValue: 'Register',
            modalContent: BYOBattery,
            // for plan card redesign in sales-monorepo only
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BYOBattery),
            contentDescription: 'BYO battery for extra value',
          },
        ],
        electricity: [
          ...electricityKeyDetailsAddons,
          {
            contentKey: DETAILS_CONTENT_KEYS.BYOBattery,
            contentValue: 'Register',
            modalContent: BYOBattery,
            // for plan card redesign in sales-monorepo only
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BYOBattery),
            contentDescription: 'BYO battery for extra value',
          },
        ],
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'purple',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'purple',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
        },
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions.html',
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
    solarInfo: {
      defaultState: {
        defaultFuel: {
          title: 'Origin Solar Boost Plus',
          content: solarInfoContent,
        },
      },
    },
  },
};
